import React from "react";
import ReviewsCard from "./reviewsCard";
import PaginationComponent from "../../UI/pagnationComponent";


const ReviewsLists = ({
  reviews,
  isLoading,
  total,
  currentPage,
  setCurrentPage,
  itemsPerPage,
  refetch
}) => {
  if (isLoading) {
    return (
      <section>
        <div className={`card rounded-4 `}>
          <div className="card-body">
            <h6 className="mb-3">التقييمات</h6>
            <div className="row ">
              {[...Array(4)].map((_, index) => (
                <div className="col-12 col-md-6 mb-4" key={index}>
                  <div
                    style={{ width: "100%", height: "300px" }}
                    className={`card ${isLoading ? "skeleton" : ""}`}
                  ></div>{" "}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section>
      <div className={`card rounded-4 `}>
        <div className="card-body">
          <h6 className="mb-3">التقييمات</h6>

          <div className="row">
            {reviews.length > 0 ? (
              reviews.map((review) => (
                <div key={review.id} className="col-12 col-md-6 mb-4">
                  <ReviewsCard review={review} refetch={refetch}/>
                </div>
              ))
            ) : (
              <div className="col-12">
                <div className="text-center py-5">
                  <p className="text-muted">لا توجد تقييمات متاحة</p>
                </div>
              </div>
            )}
          </div>

          {reviews.length > 0 && (
            <PaginationComponent
              totalItems={total}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default ReviewsLists;
